import ChooseAccountType from "../component/ChooseAccountType";
import ClubRegister from "../pages/auth/ClubRegister";
import EmailSent from "../pages/auth/EmailSent";
import EntryOption from "../pages/auth/EntryOption";
import ForgotPassword from "../pages/auth/ForgotPassword";
import GuestRegister from "../pages/auth/GuestRegister";
import Login from "../pages/auth/Login";
import MemberLogin from "../pages/auth/MemberLogin";
import MemberVerification from "../pages/auth/MemberVerification";
import Public from "../pages/auth/Public";
import ResetPassword from "../pages/auth/ResetPassword";
import UserRegister from "../pages/auth/UserRegister";

export const publicRoutes = [
    { path: "/login", element: <Public Component={Login} /> },
    { path: "/member-login", element: <Public Component={MemberLogin} /> },
    { path: "/register-user", element: <Public Component={UserRegister} /> },
    { path: "/register-club", element: <Public Component={ClubRegister} /> },
    { path: "/register-guest", element: <Public Component={GuestRegister} /> },
    { path: "/reset-password", element: <Public Component={ResetPassword} /> },
    { path: "/verify", element: <Public Component={MemberVerification} /> },
    { path: "/forgot-password", element: <Public Component={ForgotPassword} /> },
    { path: '/email-sent', element: <Public Component={EmailSent} /> },
    { path: '/account-type', element: <Public Component={ChooseAccountType} /> },
    { path: '/login-option', element: <Public Component={EntryOption} /> },
]